<template>
     <div class="businessopportunityclosed-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Open Business Opportunity" 
                />
          <b-card class="businessopportunityclosed-search-card">
                    <b-tabs card vertical >
                        <b-tab title="Business Opportunity" active>
                        <b-form>
                        <b-row>
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="businessopportunitycloseds" 
                            :fields="fielsOpportunity">

                        </b-table>
                        </transition>   
                                             
                            </b-row>
                        </b-form>

                        </b-tab >
                    </b-tabs>         
                </b-card>     
     </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'BusinessOpportunityClosed',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                businessopportunitycloseds:[],
                 isBusy: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
             
                fielsOpportunity:[
                      {
                        key: 'date_opportunity',label: 'Opportunity Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'address_immobile', label: 'Address', sortable: false ,variant: 'light'},
                    { key: 'name_type_part_immobile', label: 'Location', sortable: false ,variant: 'light'},
                    { key: 'description_item', label: 'Description', sortable: false ,variant: 'light'},
                    { key: 'value_opportunity', label: 'Value', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                    { key: 'percent_opportunity', label: '% Parther', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                     {
                        key: 'date_closed_opportunity',label: 'Closing Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },    
                    { key: 'value_closed_opportunity', label: 'Closing Value', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},   
                     { key: 'value_payment_opportunity', label: 'Payment Value', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},           
                
                ]
            }
        },
        computed: {
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rowsFinancial() {
                return this.businessopportunitycloseds.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
                        formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadFinancialDetail(){
                const url = `${baseApiUrl}/businessopportunitybyparther/${this.user.id}`
                axios(url).then(res =>{
                     this.businessopportunitycloseds = res.data
                })
            },
       


        },
        mounted(){
            this.loadFinancialDetail()
            this.showTable = true
        }
}
</script>

<style>


    .businessopportunityclosed-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .businessopportunityclosed-search button{
        font-size: 0.75rem;
    }

     .businessopportunityclosed-search select{
        font-size: 0.75rem;
    }

    .businessopportunityclosed-search input{
        font-size: 0.75rem;
    }

    .businessopportunityclosed-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }



    #modalBank {
        font-size: 0.75rem;
    }

    #modalBank button{
        font-size: 0.75rem;
    }

     #modalBank input{
        font-size: 0.75rem;
    }

      #modalBank label{
        font-size: 0.75rem;
        color: black;
    }

     #modalImmobile {
        font-size: 0.75rem;
    }

    #modalImmobile button{
        font-size: 0.75rem;
    }

     #modalImmobile input{
        font-size: 0.75rem;
    }

      #modalImmobile select{
        font-size: 0.75rem;
    }

      #modalImmobile label{
        font-size: 0.75rem;
        color: black;
    }

 #modalFinancial {
        font-size: 0.75rem;
    }

    #modalFinancial button{
        font-size: 0.75rem;
    }

     #modalFinancial input{
        font-size: 0.75rem;
    }

      #modalFinancial select{
        font-size: 0.75rem;
    }

      #modalFinancial label{
        font-size: 0.75rem;
        color: black;
    }
    
       #modalFinancial textarea{
            font-size: 0.75rem;
        }



    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
